import * as React from 'react';
import { useRange } from 'react-instantsearch';
import { AccordionItem } from '@grandvisionhq/common';
import FacetInputPriceRange from './FacetInputPriceRange.js';

const ConnectedFacetInputPriceRangeMobile = ({ onChange , id , label , attribute ,  })=>{
    const { refine , range: { max , min  } , start ,  } = useRange({
        attribute
    });
    const handleOnChange = React.useCallback((value)=>{
        onChange && onChange();
        refine([
            value.min,
            value.max
        ]);
    }, [
        onChange,
        refine
    ]);
    if (!min || !max || min === max) {
        return null;
    }
    const currentValue = {
        min: Math.max(min, Number.isFinite(start[0]) ? start[0] : min),
        max: Math.min(max, Number.isFinite(start[1]) ? start[1] : max)
    };
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: id,
        label: label,
        headingLevel: "h3"
    }, /*#__PURE__*/ React.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentValue,
        facetLabel: label,
        onChange: handleOnChange,
        renderNumber: (value)=>Math.round(value / 100)
    }));
};

export { ConnectedFacetInputPriceRangeMobile };
//# sourceMappingURL=ConnectedFacetInputPriceRangeMobile.js.map
